import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { useColumnVisibility } from '../../../contexts/ColumnVisibilityContext';

const BulkActionsBar = ({ 
  selectedCount, 
  onBulkStatusChange, 
  onBulkExport, 
  onBulkDelete, 
  onClearSelection,
  onDownloadArbeitszeit,
  onDownloadArbeitszeitOfficial
}) => {
  const [showActions, setShowActions] = useState(false);
  const { isColumnsHidden } = useColumnVisibility();

  if (selectedCount === 0) return null;

  const handleBulkAction = (action) => {
    switch (action) {
      case 'activate': onBulkStatusChange('active');
        break;
      case 'deactivate': onBulkStatusChange('inactive');
        break;
      case 'suspend': onBulkStatusChange('suspended');
        break;
      case 'export':
        onBulkExport();
        break;
      case 'delete':
        onBulkDelete();
        break;
      default:
        break;
    }
    setShowActions(false);
  };

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-40">
      <div className="bg-card border border-border rounded-lg elevation-3 p-4 min-w-96">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <Icon name="Check" size={16} color="white" />
            </div>
            <div>
              <div className="font-medium text-text-primary">
                {selectedCount} Mitarbeiter{selectedCount !== 1 ? '' : ''} ausgewählt
              </div>
              <div className="text-sm text-text-secondary">
                Wählen Sie eine Aktion für die ausgewählten Mitarbeiter
              </div>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            {/* Bulk Actions Dropdown */}
            <div className="relative">
              {/* <Button
                variant="default"
                size="sm"
                onClick={() => setShowActions(!showActions)}
                iconName="ChevronDown"
                iconPosition="right"
                className="touch-feedback"
              >
                Aktionen
              </Button> */}

              {showActions && (
                <div className="absolute bottom-full mb-2 right-0 w-48 bg-popover border border-border rounded-lg elevation-3 py-2 z-50">
                  <button
                    onClick={() => handleBulkAction('activate')}
                    className="w-full flex items-center px-4 py-2 text-sm text-text-primary hover:bg-muted transition-colors"
                  >
                    <Icon name="UserCheck" size={16} className="mr-3 text-success" />
                    Ausgewählte aktivieren
                  </button>
                  
                  <button
                    onClick={() => handleBulkAction('deactivate')}
                    className="w-full flex items-center px-4 py-2 text-sm text-text-primary hover:bg-muted transition-colors"
                  >
                    <Icon name="UserX" size={16} className="mr-3 text-warning" />
                    Ausgewählte deaktivieren
                  </button>
                  
                  <button
                    onClick={() => handleBulkAction('suspend')}
                    className="w-full flex items-center px-4 py-2 text-sm text-text-primary hover:bg-muted transition-colors"
                  >
                    <Icon name="UserMinus" size={16} className="mr-3 text-error" />
                    Ausgewählte sperren
                  </button>
                  
                  <div className="border-t border-border my-2"></div>
                  
                  <button
                    onClick={() => handleBulkAction('export')}
                    className="w-full flex items-center px-4 py-2 text-sm text-text-primary hover:bg-muted transition-colors"
                  >
                    <Icon name="Download" size={16} className="mr-3 text-primary" />
                    Ausgewählte exportieren
                  </button>
                  
                  <div className="border-t border-border my-2"></div>
                  
                  <button
                    onClick={() => handleBulkAction('delete')}
                    className="w-full flex items-center px-4 py-2 text-sm text-error hover:bg-muted transition-colors"
                  >
                    <Icon name="Trash2" size={16} className="mr-3" />
                    Ausgewählte löschen
                  </button>
                </div>
              )}
            </div>

            {/* Quick Actions */}
            

            <Button
              variant="ghost"
              size="sm"
              onClick={onClearSelection}
              iconName="X"
              className="touch-feedback"
            />
          </div>
        </div>

        {/* Quick Action Buttons */}
        <div className="flex items-center space-x-2 mt-3 pt-3 border-t border-border">
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleBulkAction('activate')}
            iconName="UserCheck"
            iconPosition="left"
            className="touch-feedback text-success border-success/20 hover:bg-success/10"
          >
            Aktivieren
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleBulkAction('deactivate')}
            iconName="UserX"
            iconPosition="left"
            className="touch-feedback text-warning border-warning/20 hover:bg-warning/10"
          >
            Deaktivieren
          </Button>
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => handleBulkAction('suspend')}
            iconName="UserMinus"
            iconPosition="left"
            className="touch-feedback text-error border-error/20 hover:bg-error/10"
          >
            Sperren
          </Button>

          {selectedCount === 1 && !isColumnsHidden && (
            <Button
              variant="outline"
              size="sm"
              onClick={onDownloadArbeitszeit}
              iconName="Download"
              iconPosition="left"
              className="touch-feedback"
            >
              Arbeitszeit ODT
            </Button>
          )}

          {selectedCount === 1 && (
            <Button
              variant="outline"
              size="sm"
              onClick={onDownloadArbeitszeitOfficial}
              iconName="FileDown"
              iconPosition="left"
              className="touch-feedback"
            >
              Arbeitszeit offiziell
            </Button>
          )}
        </div>
      </div>

      {/* Overlay */}
      {showActions && (
        <div
          className="fixed inset-0 z-30"
          onClick={() => setShowActions(false)}
        />
      )}
    </div>
  );
};

export default BulkActionsBar;